import "./component.scss"


// WEBPACK FOOTER //
// ./app/components/what_is_tinkergarten/component.js